import { useEffect } from 'react';

const RedirectPage = () => {
  useEffect(() => {
    // Redirect to an external URL
    window.location.href = 'https://admin.teammateme.net/';
  }, []);

  return null; // This component doesn't render anything since it immediately redirects
};

export default RedirectPage;
